import { render, staticRenderFns } from "./CustomsEntryRegistrations.vue?vue&type=template&id=eab7003a"
import script from "./CustomsEntryRegistrations.vue?vue&type=script&lang=js"
export * from "./CustomsEntryRegistrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports